import type { ComponentProps } from "react";
import { NftInventory } from "./NftInventory";
import { NftLookup, type NftLookupProps } from "./NftLookup";

export type NftBrowserProps = Omit<ComponentProps<typeof NftInventory>, "lookup"> & {
  lookup: NftLookupProps | null;
};

export function NftBrowser({ lookup, ...inventory }: NftBrowserProps) {
  return <NftInventory {...inventory} lookup={lookup ? <NftLookup {...lookup} /> : null} />;
}
